import { render, staticRenderFns } from "./mainbusinessPage1.vue?vue&type=template&id=7305c6b9&scoped=true&"
import script from "./mainbusinessPage1.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage1.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage1.vue?vue&type=style&index=0&id=7305c6b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7305c6b9",
  null
  
)

export default component.exports